module.exports = __webpack_public_path__ + "img/campain_icon.bf37f518.png";